if (process.client) {
	window.fancybox = require('@fancyapps/ui')
	// require('@fancyapps/ui/dist/fancybox/fancybox.css');
}